module.exports = __webpack_public_path__ + "img/D3-logos-min.615ef6e1.png";